import api from './api';

export const getMealEntitlements = (params) => api.get('/v1/meal-entitlements', { params });
export const assignMealEntitlement = (data) => api.post('/v1/meal-entitlements/assign', data);
export const updateMealEntitlement = (id, data) => api.put(`/v1/meal-entitlements/${id}`, data);
export const deleteMealEntitlement = (id) => api.delete(`/v1/meal-entitlements/${id}`);
export const deleteMealEntitlementsByUser = (userId) => api.delete(`/v1/meal-entitlements/by-user/${userId}`);
